import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "components/Common/Breadcrumb2";
import Select from "react-select";
import { Spinner } from "reactstrap";
import {
  fetchQuestionsAndAnswersRequest,
  fetchModulesRequest,
} from "store/actions";
import QuestionAndAnswersTable from "./questionsAndAnswersTable";

const QuestionAndAnswersList = () => {
  const dispatch = useDispatch();
  const { loading, questions } = useSelector((state) => state.QuestionsAndAnswers);
  const modules = useSelector((state) => state.Module.modules?.data || []);

  // ✅ Pagination & Filters
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState("");
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedSortData, setSelectedSortData] = useState({
    value: "createdAt",
    direction: "desc",
  });

  // ✅ Fetch modules once
  useEffect(() => {
    dispatch(fetchModulesRequest());
  }, [dispatch]);

  // ✅ Fetch questions whenever filters change
  useEffect(() => {
    const params = {
      page: pageIndex,
      limit: pageSize,
      ...(searchString ? { search: searchString } : {}),
      ...(selectedModule ? { moduleId: selectedModule.value } : {}),
      sortBy: `${selectedSortData.value}:${selectedSortData.direction}`,
    };
    dispatch(fetchQuestionsAndAnswersRequest(params));
  }, [ pageIndex, pageSize, searchString, selectedModule, selectedSortData]);

  const moduleOptions =
    modules?.map((m) => ({
      label: m.title,
      value: m._id,
    })) || [];

  return (
    <div className="page-content container-fluid">
      {/* 🔹 Header */}
      <div className="d-flex justify-content-between align-items-center mx-3 mb-3">
        <Breadcrumb
          title="Questions & Answers"
          breadcrumbItems={[
            { title: "Dashboard", link: "/dashboard" },
            { title: "Questions & Answers", link: "#" },
          ]}
        />
      </div>

      {/* 🔹 Table */}
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
          <Spinner color="primary" />
        </div>
      ) : (
        <QuestionAndAnswersTable
          data={questions?.data || []}
          totalrows={questions?.totalRecords || 0}
          loading={loading}
          moduleOptions={moduleOptions}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          pageSize={pageSize}
          setPageSize={setPageSize}
          searchString={searchString}
          setSearchString={setSearchString}
          selectedModule={selectedModule}
          setSelectedModule={setSelectedModule}
          selectedSortData={selectedSortData}
          setSelectedSortData={setSelectedSortData}
        />
      )}
    </div>
  );
};

export default QuestionAndAnswersList;
